import { COMPANY_INFO, SERVICES_DATA } from "@/mocks/aegis-data";

const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-aegisMid text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="space-y-5">
          <div>
            <img
              src={COMPANY_INFO.logoUrl}
              alt="Aegis Construction Services"
              className="h-14 w-auto object-contain brightness-0 invert"
            />
          </div>
          <p className="font-inter text-white/60 text-sm leading-relaxed">
            Florida Certified General Contractor<br />
            License: <span className="text-aegisGold">CGC1524141</span><br />
            Plumbing: <span className="text-aegisGold">CFC1430823</span>
          </p>
          <p className="font-inter text-white/50 text-xs">
            Serving Sarasota, Manatee & Charlotte Counties — Including All Barrier Islands
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a href={COMPANY_INFO.social.facebook} target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center border border-white/20 hover:border-aegisGold hover:text-aegisGold text-white/60 transition-colors duration-200 cursor-pointer">
              <i className="ri-facebook-fill text-sm" />
            </a>
            <a href={COMPANY_INFO.social.twitter} target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center border border-white/20 hover:border-aegisGold hover:text-aegisGold text-white/60 transition-colors duration-200 cursor-pointer">
              <i className="ri-twitter-x-fill text-sm" />
            </a>
            <a href={COMPANY_INFO.social.linkedin} target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center border border-white/20 hover:border-aegisGold hover:text-aegisGold text-white/60 transition-colors duration-200 cursor-pointer">
              <i className="ri-linkedin-fill text-sm" />
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-inter text-xs tracking-widest uppercase text-aegisGold mb-5">Services</h4>
          <ul className="space-y-2.5">
            {SERVICES_DATA.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => scrollTo("#services")}
                  className="font-inter text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer text-left"
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="space-y-4">
          <h4 className="font-inter text-xs tracking-widest uppercase text-aegisGold mb-5">Contact</h4>
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-map-pin-line text-aegisGold text-sm" />
            </div>
            <p className="font-inter text-sm text-white/60 leading-relaxed">
              4430 Ashton Rd<br />Sarasota, FL 34233
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-aegisGold text-sm" />
            </div>
            <a href={COMPANY_INFO.phoneHref}
              className="font-inter text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
              {COMPANY_INFO.phone}
            </a>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-aegisGold text-sm" />
            </div>
            <a href={`mailto:${COMPANY_INFO.email}`}
              className="font-inter text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
              {COMPANY_INFO.email}
            </a>
          </div>
          <div className="pt-4 border-t border-white/10">
            <h4 className="font-inter text-xs tracking-widest uppercase text-aegisGold mb-3">Navigate</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: "Services", id: "#services" },
                { label: "Process", id: "#process" },
                { label: "Why Us", id: "#why-us" },
                { label: "Contact", id: "#contact" },
              ].map((l) => (
                <button
                  key={l.id}
                  onClick={() => scrollTo(l.id)}
                  className="font-inter text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer text-left"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Map */}
        <div>
          <h4 className="font-inter text-xs tracking-widest uppercase text-aegisGold mb-5">Find Us</h4>
          <div className="w-full h-48 overflow-hidden">
            <iframe
              src={COMPANY_INFO.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Aegis Construction Services Location"
            />
          </div>
          <p className="font-inter text-xs text-white/40 mt-3 leading-relaxed">
            4430 Ashton Rd, Sarasota FL 34233
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-inter text-xs text-white/40">
            © 2025 Aegis Construction Services LLC. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="font-inter text-xs text-white/40">CGC1524141 · CFC1430823</span>
          </div>
        </div>
      </div>
    </footer>
  );
}